import {
  styled,
  Button as MuiButton,
  Typography as MuiTypography
} from "@mui/material";
import {
  cancelRed,
  crusta,
  shipCove,
  white
} from "../../../../assets/styles/colors";

const PREFIX = "SignatureStatusDialogStyles";
export const classes = {
  signerButton: `${PREFIX}-signerButton`,
  cancelButton: `${PREFIX}-cancelButton`,
  errorMessageTypography: `${PREFIX}-errorMessageTypography`
};

export const Button = styled(MuiButton)(() => ({
  [`&.${classes.signerButton}`]: {
    color: white,
    backgroundColor: crusta
  },
  [`&.${classes.cancelButton}`]: {
    color: white,
    backgroundColor: shipCove
  }
}));

export const Typography = styled(MuiTypography)(() => ({
  [`&.${classes.errorMessageTypography}`]: {
    color: cancelRed,
    fontWeight: "bold"
  }
}));
